/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Faq_Sovereignty_QuestionInputs */

const en_landing_faq_sovereignty_question = /** @type {(inputs: Landing_Faq_Sovereignty_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Does our research stay inside our firm?`)
};

/**
* | output |
* | --- |
* | "Does our research stay inside our firm?" |
*
* @param {Landing_Faq_Sovereignty_QuestionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_faq_sovereignty_question = /** @type {((inputs?: Landing_Faq_Sovereignty_QuestionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Faq_Sovereignty_QuestionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_faq_sovereignty_question(inputs)
});